export enum ReferencePickerType {
  LABEL,
  LABEL_TITLE,
  LABEL__S,
  TITLE, // title__a
  LABEL_OR_TITLE,
  TITLE__S,
}
